import React from "react";
import { arrayOf, object, oneOf, shape, string } from "prop-types";
import LinksBlock from "@insightfulscience/contentful/Apps/components/LinksBlock";
import HeroBlock from "@insightfulscience/contentful/Apps/components/HeroBlock";
import VisualCopyBlock from "@insightfulscience/contentful/Apps/components/VisualCopyBlock";
import CopyBlock from "@insightfulscience/contentful/Apps/components/CopyBlock";
import TestimonialsBlock from "@insightfulscience/contentful/Apps/components/TestimonialsBlock";
import FeaturedContentBlock from "@insightfulscience/contentful/Apps/components/FeaturedContentBlock";
import Menu from "../Apps/Standard/components/Menu";

const renderBlockByTypeFactory = (slug, components, menu) => {
	const renderBlockByType = ({ sys: { contentType, id }, fields }) => {
		// Don't show draft blocks
		if (!contentType) return null;

		const {
			sys: { id: type },
		} = contentType;

		const LinkSection = components?.linksBlock || LinksBlock;
		const VisualCopySection = components?.visualCopyBlock || VisualCopyBlock;
		const HeroBlockSection = components?.heroBlock || HeroBlock;
		const CopyBlockSection = components?.blockCopy || CopyBlock;
		const TestimonialsBlockSection = components?.testimonialsBlock || TestimonialsBlock;
		const FeaturedContentSection = components?.blockFeaturedContent || FeaturedContentBlock;

		switch (type) {
			case "blockLinks":
				return menu.length > 0 ? null : <LinkSection key={id} {...fields} />;
			case "blockHero":
				return (
					<>
						<HeroBlockSection key={id} {...fields} />
						{menu.length > 0 && <Menu key="pageMenu" items={menu} />}
					</>
				);
			case "blockVisualCopy":
				return <VisualCopySection key={id} {...fields} components={components} />;
			case "blockCopy":
				return <CopyBlockSection key={id} id={id} {...fields} components={components} />;
			case "blockTestimonials":
				return <TestimonialsBlockSection key={id} {...fields} components={components} />;
			case "blockFeaturedContent":
				return <FeaturedContentSection key={id} {...fields} components={components} slug={slug} />;
			default:
				return null;
		}
	};

	renderBlockByType.propTypes = {
		sys: shape({
			contentType: shape({
				sys: shape({
					id: oneOf([
						"blockLinks",
						"blockHero",
						"blockVisualCopy",
						"blockCopy",
						"blockTestimonials",
						"blockFeaturedContent",
					]),
				}),
			}),
		}),
		fields: object, // eslint-disable-line react/forbid-prop-types
		menu: arrayOf(
			shape({
				id: string,
				title: string,
				items: arrayOf(
					shape({
						id: string,
						title: string,
					}),
				),
			}),
		),
	};

	return renderBlockByType;
};

export default renderBlockByTypeFactory;
